export const calculateHeight = (width: number, aspectRatio: number) => {
  return width / aspectRatio
}

export const calculateWidth = (height: number, aspectRatio: number) => {
  return height * aspectRatio
}
